module.exports = __webpack_public_path__ + "img/wsq-bg-btm.f6e475f3.png";